export const SevenDaysNotFrozen = ['19', '23'];

export const SevenDaysFrozenClass = ['26', '31', '33'];
export const SevenDaysFrozenStorage = '50';

// grouping one
export const NeverPickUpOneClass = ['15', '26', '30', '32'];
export const NeverPickUpOneGroup = [
  '2073',
  '2075',
  '1885',
  '7558',
  '6130',
  '6110',
  '6090',
  '3640',
  '2135',
  '8249',
  '8268',
  '8271',
  '8283',
];
export const NeverPickUpOneStorage = ['31', '30'];

// grouping two
export const NeverpPckUpTwoClass = ['21', '25'];
export const NeverPickUpTwoStorage = ['33', '34', '35', '52', '50'];

// grouping three
export const NeverPickUpThreeClass = ['21', '25', '31', '33', '35'];
export const NeverPickUpThreeStorage = ['30', '31', '32', '36'];

export const NeverPickUpStockYardBrand = 'stock yards';
